// extracted by mini-css-extract-plugin
module.exports = {"outer-shadow":"Dropdown_outer-shadow__o6H2b","dropdown-menu":"Dropdown_dropdown-menu__0sb_B"};